import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Trans, useTranslation} from 'react-i18next';
import {Button, Form, message} from 'antd';
import {useResendConfirmation} from '../../hooks/useAuthentication';
import PageLayout from '../../components/PageLayout';


function SignUpSent({email}) {
  const {t} = useTranslation('authentication');
  const onSuccess = useCallback(() => {
    message.success(t('signup.resendSuccess'));
  }, [t]);

  const {onResendConfirmation, isLoading, error} = useResendConfirmation(onSuccess);

  const subtext = <Trans i18nKey="authentication:signup.sentSubtext" values={{email}}
    components={{
      alert: <div className={'my-4 ant-alert ant-alert-success ant-alert-no-icon'}/>,
      brake: <div className={'mb-4'}/>,
      bold: <strong/>
    }}/>;


  const handleSend = () => onResendConfirmation(email);

  return (
    <PageLayout title={'signup.sentTitle'} subtext={subtext} error={error}>

      <Form.Item>
        <Button
          size={'large'}
          disabled={isLoading}
          loading={isLoading}
          onClick={handleSend}
          type="primary"
          className="  w-full">
          {t('signup.resend')}
        </Button>
      </Form.Item>

    </PageLayout>
  );
}

export default memo(SignUpSent);

SignUpSent.propTypes = {
  email: PropTypes.string
};
